module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/service-image-en--sp-6f85e0463f5126398a288ae65419560b.png";